import { MenuContext } from "./MenuContext";

export function MenuProvider({ value, children }) {
    //console.log(value);
  return (
    
    <MenuContext.Provider value={value}>
      {children}
    </MenuContext.Provider>
  );
}
